import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

const ProductContext = createContext();

const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);

  ProductProvider.propTypes = {
    children: PropTypes.any.isRequired,
  };

  useEffect(() => {
    fetch("https://domains-marketplace-backend.vercel.app/domain/availableproducts")
      .then((response) => {
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const activeProducts = data.filter(
          (product) =>
            product.status?.toLowerCase() === "active" ||
            product.available === true ||
            product.isActive === true
        );
        setProducts(activeProducts);
      })
      .catch(() => {
        // Error handled silently
      });
  }, []);

  return (
    <ProductContext.Provider value={products}>
      {children}
    </ProductContext.Provider>
  );
};

export { ProductContext, ProductProvider };
